/**
 * Роли модуля academy (внутренняя админка контента).
 *
 * ⚠️ Внешние пользователи (продавцы/дилеры) — ВНЕ RBAC: их доступ проверяется
 * в хендлерах (resolveParticipant/row-scoping). Эти роли — только для
 * сотрудников, управляющих контентом и заявками через основную панель Ayo.
 */
export const ACADEMY_ROLES = {
  /** Полный доступ: контент + заявки на призы + ручная корректировка баллов. */
  ACADEMY_ADMIN: 'ACADEMY_ADMIN',
  /** Контент-менеджер: модули, уроки, экзамены, вопросы, призы, FAQ. */
  ACADEMY_CONTENT: 'ACADEMY_CONTENT',
  /** Модератор: обработка заявок на призы, просмотр участников. */
  ACADEMY_MODERATOR: 'ACADEMY_MODERATOR',
} as const;

/** Определения ролей для defineRole (setup.ts) и UI. */
export const ACADEMY_ROLE_DEFS = [
  {
    role_code: ACADEMY_ROLES.ACADEMY_ADMIN,
    name: 'academy_admin',
    description: 'Академия: полный доступ (контент, заявки на призы, корректировка баллов)',
  },
  {
    role_code: ACADEMY_ROLES.ACADEMY_CONTENT,
    name: 'academy_content',
    description: 'Академия: управление контентом (модули, уроки, экзамены, вопросы, призы, FAQ)',
  },
  {
    role_code: ACADEMY_ROLES.ACADEMY_MODERATOR,
    name: 'academy_moderator',
    description: 'Академия: модерация заявок на призы, просмотр участников',
  },
] as const;

/** TypeScript-тип для ролей academy. */
export type AcademyRole = (typeof ACADEMY_ROLES)[keyof typeof ACADEMY_ROLES];
